'use client';

import { c as _c } from "react/compiler-runtime";
import { IFRAME_SEARCH_PARAM_KEYS } from '@/constants/iframe';
import { queryParametersSchema } from '@/schemas/room';
import { useParams, useSearchParams } from 'next/navigation';
export const useEnableFull3d = () => {
  const $ = _c(2);
  const params = useParams();
  const roomId = params?.roomId;
  const sceneId = params?.sceneId;
  const searchParams = useSearchParams();
  if (sceneId) {
    return true;
  }
  let t0;
  if ($[0] !== searchParams) {
    const full3dParam = searchParams?.get(IFRAME_SEARCH_PARAM_KEYS.FULL3D);
    t0 = queryParametersSchema.safeParse({
      full3d: full3dParam
    });
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const parseResult = t0;
  const enableFull3d = Boolean(roomId && parseResult.success && parseResult.data.full3d);
  return enableFull3d;
};